<template>
  <div class="container">
    <home-title
      title="行业教程推荐"
      link="https://lib.yiihuu.com/list/index.php"
      :icon="require('@/assets/images/home/home_title/icon2.svg')"
    ></home-title>
    <div
      class="industry_box"
      v-loading="loading"
    >
      <div class="industry_top">
        <div
          :class="e.vic_id == industryNum ? 'top_item active' : 'top_item'"
          v-for="e in induData"
          :key="e.vic_id"
          @click="cutIndustry(e.vic_id)"
        >
          {{ e.vic_name }}
        </div>
      </div>
      <div class="course_box">
        <div
          class="course_item"
          v-for="e in industryList"
          :key="e.album_id"
          @click="goStudent(e.album_id)"
        >
          <img class="course_img" :src="$homeSrc(e.album_smpicpath)" alt="" />
          <div class="course_info">
            <p class="toh2">
              {{ e.album_name }}
            </p>
            <div class="info_bottom">
              <div class="left dfAic">
                <img src="@/assets/images/home/item_icon1.svg" alt="" />{{
                  e.album_level_sort
                }}
              </div>
              <div class="right dfAic">
                <img src="@/assets/images/home/item_icon2.svg" alt="" />{{
                  e.play_count
                }}人在学
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cut ta3" @click="getList()">
      换一批 <i class="el-icon-refresh ta3"></i>
    </div>
  </div>
</template>

<script>
import homeTitle from "./components/homeTitle";
import { getIndexRecommend } from "@/api/home";
export default {
  name: "industryCourse",
  components: { homeTitle },
  data() {
    return {
      induData: [],
      industryList: [],
      industryNum: 0,
      loading: true,
    };
  },

  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      getIndexRecommend({ industry_id: this.industryNum }).then((res) => {
        this.induData = res.data.indu_data;
        this.induData.unshift({ vic_id: 0, vic_name: "综合推荐" });
        this.industryList = res.data.recommend_data;
        this.loading = false;
      });
    },
    cutIndustry(val) {
      this.industryNum = val;
      this.getList();
    },
    goStudent(id) {
      window.open(`https://lib.yiihuu.com/video/album.php?aid=${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 50px 0 30px;
  .industry_box {
    .industry_top {
      width: 100%;
      height: 80px;
      background: rgba(255, 255, 255, 0.39);
      box-shadow: 0px 0px 18px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      padding: 0 85px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .top_item {
        font-size: 14px;
        line-height: 19px;
        color: #333;
        transition: 0.3s;
        cursor: pointer;
        position: relative;

        &::after {
          content: "";
          display: inline-block;
          width: 0;
          height: 2px;
          background: #22b79e;
          position: absolute;
          bottom: -12px;
          right: 0;
          left: auto;
          transition: 0.3s;
          margin: 0 18%;
        }
        &:hover {
          color: #22b79e;
          font-weight: bold;
          &::after {
            width: 64%;
            right: auto;
            left: 0;
          }
        }
      }
      .active {
        color: #22b79e;
        font-weight: bold;
        &::after {
          content: "";
          display: inline-block;
          width: 64%;
          height: 2px;
          background: #22b79e;
          position: absolute;
          bottom: -12px;
          right: 0;
          left: auto;
          transition: 0.3s;
          margin: 0 18%;
        }
      }
    }
  }
  ::v-deep .el-loading-spinner .path  {
    stroke: #0dc8a8;
  }
  .course_box {
    .course_item {
      margin-bottom: 20px;
    }
  }
  .cut {
    width: 150px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #ddd;
    border-radius: 100px;
    font-size: 14px;
    color: #999;
    margin: 0 auto;
    cursor: pointer;
    i {
      transform: rotateY(180deg);
    }
    &:hover {
      border: 1px solid #22b79e;
      color: #22b79e;
      i {
        transform: rotateX(-180deg);
      }
    }
  }
}
@media screen and (max-width: 1500px) and (min-width: 270px) {
  .course_item {
    &:nth-child(9) {
      display: none;
    }
    &:nth-child(10) {
      display: none;
    }
  }
}
</style>
